import { IMenuVariant } from '@/shared/model/menu-variant.model';
import { IAddon } from '@/shared/model/addon.model';

export interface IPrice {
  id?: number;
  oldPrice?: number | null;
  newPrice?: number | null;
  menuVariant?: IMenuVariant | null;
  addon?: IAddon | null;
}

export class Price implements IPrice {
  constructor(
    public id?: number,
    public oldPrice?: number | null,
    public newPrice?: number | null,
    public menuVariant?: IMenuVariant | null,
    public addon?: IAddon | null
  ) {}
}
